import { apiWithToken } from '../api';

const resouceUrl = '/resposta_questao_memorial';
const token = localStorage.getItem('@token');
let api = apiWithToken(token);

export const load = async (params) => {
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  let page = urlParams.has('page') ? { page: urlParams.get('page') } : {};
  let search = urlParams.has('search')
    ? { search: urlParams.get('search') }
    : {};
  return await api.get(`${resouceUrl}`, {
    params: {
      ...params,
      ...page,
      ...search,
    },
  });
};

export const select = async () => {

  return await api.get(`${resouceUrl}`, {
    params: {
      fields:'id,nome',
      raw_list: true
    }
  });
};

export const show = async (id, params) => {
  return await api.get(`${resouceUrl}/${id}`, params);
}

export const update = async (id, resposta_questao_memorial) => {
  return await api.put(`${resouceUrl}/${id}`, resposta_questao_memorial);
}


export const store = async (resposta_questao_memorial) => {
  let response = await api.post(resouceUrl , resposta_questao_memorial);
  return response;
}

export const destroy = async (id) => {

  return await api.delete(`${resouceUrl}/${id}`);
}
